//MARK: Done
//NOTE: Better error handling?
import { notifySimple } from "providers/toast";
import { gateway } from "./baseClient";
import { isAxiosError } from "axios";
import type { RequestData, ResponseData } from "../types/api";

export default async function makeApiRequest(
  { url, method, data, params }: RequestData,
  gatewayToUse: any = gateway,
  showToastMessage: boolean = true
): Promise<ResponseData> {
  try {
    const response = await gatewayToUse({
      url,
      method,
      data,
      params,
    });
    return {
      data: response.data,
      status: response.status,
      isLoading: false,
    };
  } catch (error: any) {
    let status = error.response?.status || 500;
    let errorMessage = "Unknown error occurred";

    if (error.response?.data) {
      const responseData = error.response.data;
      // Try multiple possible error message locations
      const possibleMessage =
        responseData.err?.message ||
        responseData.message ||
        responseData.detail ||
        responseData.error;

      if (possibleMessage) {
        // Ensure it's a string
        errorMessage =
          typeof possibleMessage === "string"
            ? possibleMessage
            : JSON.stringify(possibleMessage);
      } else if (typeof responseData === "string") {
        errorMessage = responseData;
      } else {
        // If responseData is an object without recognizable error fields
        errorMessage = JSON.stringify(responseData);
      }
    } else if (isAxiosError(error) && error.message) {
      errorMessage = String(error.message);
    } else if (error?.message) {
      errorMessage = String(error.message);
    }

    // Final safety check: ensure errorMessage is always a string
    if (typeof errorMessage !== "string") {
      errorMessage = "Unknown error occurred";
    }

    if (showToastMessage) {
      notifySimple(errorMessage, "error");
    }
    return {
      data: [],
      status: status,
      isLoading: false,
      error: errorMessage,
    };
  }
}
